import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosAPI from "../../api/axiosAPI";

//----------- add new product ----------------//
export const addProduct = createAsyncThunk("addProduct", async (data) => {
    try {
        const response = await axiosAPI.post("/add-product", data)
        return response
    } catch (err) {
        console.log(err)
        return err
    }
});

//------------ Get all product with pagination -------------//
export const getAllProduct = createAsyncThunk("getAllProduct", async ({ page, limit, search, brand }) => {
    try {
        const response = await axiosAPI.get(`/get-all-product?page=${page}&limit=${limit}&search=${search}&brandId=${brand}`);
        return response;
    } catch (err) {
        console.log(err)
        return err
    }
});

//=========== Get all brand without pagination ===============//
export const allProductNoPagination = createAsyncThunk("allProductNoPagination", async () => {
    try {
        const response = await axiosAPI.get("/get-all-product");
        return response;
    } catch (err) {
        return err
    }
});

//-------------- Get single product --------------------//
export const getProduct = createAsyncThunk("getProduct", async (id) => {
    try {
        const response = await axiosAPI.get(`/get-product/${id}`);
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all product count ===================//
export const getAllProductCount = createAsyncThunk("getAllProductCount", async () => {
    try {
        const response = await axiosAPI.get("/all-product-count");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all inactive product ===================//
export const getInActiveProduct = createAsyncThunk("getInActiveProduct", async () => {
    try {
        const response = await axiosAPI.get("/get-inactive-product");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all active product ===================//
export const getActiveProduct = createAsyncThunk("getActiveProduct", async () => {
    try {
        const response = await axiosAPI.get("/get-active-product");
        return response;
    } catch (err) {
        return err
    }
});

//---------- toggle product status ----------------//
export const toggleProductStatus = createAsyncThunk("toggleProductStatus", async (data) => {
    try {
        const { id } = data;
        const response = await axiosAPI.put(`/toggle-product-status/${id}`);
        return response;
    } catch (err) {
        return err
    }
});

//---------- toggle product trending ----------------//
export const toggleProductTrending = createAsyncThunk("toggleProductTrending", async (data) => {
    try {
        const { id } = data;
        const response = await axiosAPI.put(`/product/${id}/trending`);
        return response;
    } catch (err) {
        return err
    }
});

//----------- update product ----------------//
export const updateProduct = createAsyncThunk("updateProduct", async (data) => {
    try {
        const { id, values } = data;
        const response = await axiosAPI.put(`/update-product/${id}`, values);
        return response
    } catch (err) {
        return err
    }
})